module.exports = __webpack_public_path__ + "05d7a764.svg";